import { getAuthorByName } from "@/data/authors";
import type { DesignPerspective } from "@/data/perspectives";
import s from "./style.module.css";
export interface Input extends DesignPerspective {
    theme: string;
    active: boolean;
    onClick(e: PointerEvent): void;
}

<const/author=getAuthorByName(input.author)>

<li class=s.item data-color=input.theme>
    <button/buttonRef
        class=s.button
        data-active=`${input.active}`
        onClick(e) {
            input.onClick(e);
        }>
        <div class=s.imageContainer>
            <img class=s.image src=input.src alt=input.alt>
            <div>
                <p>${input.description}</p>
            </div>
        </div>
        <avatar user=author class=s.avatar/>
    </button>
</li>
